

/**
 * 多语言配置，调用$translate.instant("key") 或者 translate filter在html上绑定 如： {{ 'key' | translate }}，即可获取
 */
let language = {
    BUILDER_COPYRIGTH_TITLE: "你的设计版权",
    BUILDER_COPYRIGTH_DES1: "在完成订单之前，请仔细检查您的设计，因为我们的团队不会对其进行任何额外的编辑。请确认以下内容:",
    BUILDER_COPYRIGTH_DES2: "我确认在我的设计中添加的所有图像，名称和其他内容都是正确的，我拥有所有版权或完全授权使用。",
    BUILDER_COPYRIGTH_CANCEL_BTN:"取消",
    BUILDER_COPYRIGTH_CONFIRM_BTN:"确定"
};

export { language }